import 'App_new.css';
import { useNavigate } from 'react-router-dom';
import { createTheme } from '@mui/material/styles';
import { AuthContextProvider } from 'hooks/useAuth';
import { CompanyContextProvider } from 'hooks/useCompany';
import { RouterProvider } from 'react-router-dom';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import router from 'routes';
import Snackbar from 'components/@extended/Snackbar';
import Locales from 'components/Locales';
import { ModalProvider } from '../src/components/Modal/ModalContext'; // <-- ✅ Import this
import DetectRefresh from 'utils/detectRefersh';
import { useSync } from 'services/useSync';

const NotFound = () => {
  const navigate = useNavigate();

  setTimeout(() => {
    navigate('/quick-hits');
  }, 2500);

  return (
    <div style={{
      display: "grid",
      height: '100vh',
      width: '100vw',
      placeItems: 'center',
      textAlign: 'center'
    }}>
      <div>
        <h1 style={{ fontSize: '72px', margin: 0 }}>404</h1>
        <h2 style={{ fontSize: '36px', margin: '10px 0' }}>Page Not Found</h2>
        <p style={{ fontSize: '18px' }}>Redirecting to Home Screen...</p>
      </div>
    </div>
  );
};

function App() {
  // useSync();
  return (
    <ThemeCustomization>
      <Locales>
        <ScrollTop>
          <CompanyContextProvider>
            <AuthContextProvider>
              <ModalProvider> {/* ✅ Wrap everything that uses useModal */}
                <>
                  <DetectRefresh />
                  <RouterProvider router={router} />
                  <Snackbar />
                </>
                {/* <AppContent /> */}
              </ModalProvider>
            </AuthContextProvider>
          </CompanyContextProvider>
        </ScrollTop>
      </Locales>
    </ThemeCustomization>
  );
}
// const AppContent = () => {
//   useSync(); // ✅ Now this has access to CompanyContext
//   return (
//     <>
//       <DetectRefresh />
//       <RouterProvider router={router} />
//       <Snackbar />
//     </>
//   );
// };
export default App;
